// extracted by mini-css-extract-plugin
export var avatar = "avatar-select-module--avatar--cc5a2";
export var root = "avatar-select-module--root--fdfee";
export var selectButton = "avatar-select-module--selectButton--103af";
export var selectButtonL = "avatar-select-module--selectButtonL--a3669";
export var selectButtonR = "avatar-select-module--selectButtonR--9c021";